import createClient from 'openapi-fetch';

const client = createClient({
    baseUrl: '/api/v1',
    credentials: 'include',
});

export async function listVendorCommissions() {
    const { data, error } = await client.GET('/vendor/commissions');
    if (error) {
        throw new Error(error?.detail || 'خطا در دریافت لیست خریدها');
    }
    return data || [];
}

export async function approveVendorCommission(id) {
    const { data, error } = await client.POST(`/vendor/commissions/${id}/approve`);
    if (error) throw new Error(error?.detail || 'خطا در تأیید پورسانت');
    return data;
}

export async function cancelVendorCommission(id) {
    const { data, error } = await client.POST(`/vendor/commissions/${id}/cancel`);
    if (error) throw new Error(error?.detail || 'خطا در لغو پورسانت');
    return data;
}

export async function getVendorReports() {
    const { data, error } = await client.GET('/vendor/commissions/reports');
    if (error) throw new Error(error?.detail || 'خطا در دریافت گزارش‌ها');
    return data;
}

// 👈 این تابع باید اینجا باشد تا خطا برطرف شود
export async function getPackageBuyers(packageId) {
    const { data, error } = await client.GET(`/vendor/commissions/packages/${packageId}/buyers`);
    if (error) throw new Error(error?.detail || 'خطا در دریافت لیست خریداران');
    return data || [];
}